export default __webpack_public_path__ + "static/media/POS-Saral-Nivesh-Brochure.9defa862.pdf";